export default __webpack_public_path__ + "static/media/kate-el-bizri.0569b44c.png";